var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("About")]),_c('h3',[_vm._v("Version Number "+_vm._s(this.versionData[this.versionData.length-1].versionNo))]),_c('p',[_vm._v("About this Version: "+_vm._s(this.versionData[this.versionData.length-1].description))])])}
var staticRenderFns = []

export { render, staticRenderFns }